import React, { useState } from "react";

const MissionVision = () => {
  const [hoveredValue, setHoveredValue] = useState(null);

  const values = [
    {
      id: 1,
      title: "Built for People",
      description: "Every decision starts with improving human lives.​",
    },
    {
      id: 2,
      title: "Designed to Connect",
      description: "Healthcare works best when systems work together",
    },
    {
      id: 3,
      title: "Intelligence with Intent",
      description:
        "We use AI and data responsibly to enable better decisions, proactive care, and real impact.",
    },
    {
      id: 4,
      title: "Trust & Integrity at the core",
      description:
        "We are committed to privacy, security, compliance, and ethical use of technology—without compromise.​",
    },
    {
      id: 5,
      title: "Simplicity in Complexity",
      description: "Healthcare is complex—we make it usable.",
    },
    {
      id: 6,
      title: "Evolving with Purpose",
      description:
        "We learn fast, adapt continuously, and innovate with purpose.​",
    },
  ];

  return (
    <section className="py-12 md:py-16 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          {/* LEFT */}
          <div className="lg:col-span-7  flex flex-col justify-center">
            <h2 className="font-bold mb-6">
              Our Mission & <span className="">Vision</span>
            </h2>

            <div className="space-y-4   leading-relaxed">
              <p>
                To empower individuals and communities to live healthier lives
                through intelligent, connected care.
              </p>

              <p>
                Reinventing the future of healthcare through a connected
                intelligent digital health platform—accessible to everyone,
                anywhere, anytime.
              </p>
            </div>

            {/* VALUES */}
            <div className="mt-8 md:mt-10">
              <h3 className="  font-bold mb-4 underline">
                Values
              </h3>

              <div className="flex flex-wrap gap-y-3">
                {values.map((value, index) => (
                  <div
                    key={value.id}
                    className="relative flex items-center flex-wrap"
                  >
                    <span
                      className="text-xs md: cursor-pointer hover:text-orange-400 transition"
                      onMouseEnter={() => setHoveredValue(value.id)}
                      onMouseLeave={() => setHoveredValue(null)}
                    >
                      {value.title}
                    </span>

                    {/* separator */}
                    {index !== values.length - 1 && (
                      <span className="mx-2">|</span>
                    )}

                    {/* TOOLTIP */}
                    {hoveredValue === value.id && (
                      <div className="absolute left-0 top-full mt-2 z-50 w-56 md:w-64">
                        <div className="bg-white text-gray-800 rounded-lg shadow-lg p-3 relative">
                          <div className="absolute -top-2 left-4 w-3 h-3 bg-white rotate-45"></div>

                          <p className="text-xs md:">
                            {value.description}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="lg:col-span-5 flex justify-center lg:justify-end">
            <div className="w-full max-w-md rounded-tl-lg overflow-hidden shadow-xl">
              <img
                src="/assets/whoWeAre/2section.svg"
                alt="Mission and Vision"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
